export enum CustomHeader {
  /**
   * Requests the client to redirect to another location.
   */
  LemmaApiLocation = "lemma-api-location",

  /**
   * Requests the client to open a modal.
   */
  LemmaApiModal = "lemma-api-modal"
}
